
if (window.matchMedia("(max-width: 768px)").matches) {
let footerBlockH2s = document.querySelectorAll('footer .footer__block--menu h2');
footerBlockH2s.forEach(h2 => {
    h2.addEventListener('click', (e) => {
        let nextDiv = e.target.nextElementSibling;
        e.currentTarget.parentNode.classList.add('active')
        let divs = document.querySelectorAll('footer .footer__quicklinks');
        if(divs.length > 0) {
            divs.forEach(div => {
                if(div !== nextDiv) {
                    div.parentNode.classList.remove('active')
                }
            });
        }
    });
});
}

var selector = document.querySelectorAll(".selector-language");
selector.forEach(element => {
    element.addEventListener("change", function () {
        const selectedOption = element.options[element.selectedIndex];
        const url = selectedOption.getAttribute("data-url");
        if (url !== null && url !== "") {
          window.location.href = url;
        }
        var selectedLanguage = this.value;
        var currentUrl = window.location.href;
        var defaultLanguage = element[0].value;
        var baseUrl = currentUrl.split("/")[0] + "//" + currentUrl.split("/")[2];
        var path = currentUrl.substring(baseUrl.length);
        var hasLanguagePath = path.match(/^\/[a-z]{2}\//);
        if (selectedLanguage !== defaultLanguage) {
            if (!hasLanguagePath) {
                window.location.href = baseUrl + '/' + selectedLanguage + path;
            } else {
                window.location.href = baseUrl + '/' + selectedLanguage + path.substring(3);
            }
        } else {
            if (hasLanguagePath) {
                window.location.href = baseUrl + path.substring(3);
            }
        }
    });
});
 
//modal Geolocation
 // Get the modal
 var modal = document.getElementById("modal_geolocation");
 // Get the <span> element that closes the modal
 var span = document.getElementsByClassName("geolocation_close")[0];
 let selectedCountry = null;
 let urlCountry = null;
 
 // When the user clicks on the button, open the modal
 openModalGeolocation = function () {
   modal.style.display = "block";
   document.body.classList.add("modal-open");
   if (window.matchMedia("(min-width: 768px)").matches) {
     const input = document.getElementById('country-search-input');
     const dropdown = document.getElementById('country-dropdown-list');
     const error = document.getElementById('country-search-error');
     const wrapper = document.querySelector('.country-search-wrapper');
     
     if (input) input.value = '';
     if (dropdown) {
       dropdown.style.display = 'none';
       dropdown.querySelectorAll('li').forEach(li => li.style.display = '');
     }
     if (error) error.style.display = 'none';
     if (wrapper) wrapper.classList.remove('open');
     
     document.querySelectorAll('.redirect-stores-SP').forEach(r => r.checked = false);
     selectedCountry = null;
     urlCountry = null;
   }
 }
 // When the user clicks on <span> (x), close the modal
 span.onclick = function () {
   modal.style.display = "none";
   document.body.classList.remove("modal-open");
 }
 // When the user clicks anywhere outside of the modal, close it
 window.onclick = function (event) {
   if (event.target == modal) {
     modal.style.display = "none";
     document.body.classList.remove("modal-open");
   }
 }

 // add event function to close select on click
function closeSelect(){
    document.querySelector('#details_contact-form').removeAttribute('open');
}

const inputCountries = document.querySelectorAll('.redirect-stores-SP');
const SelectinputCountries = document.querySelector('.redirect-stores-SP-mobile');
const confirmButton = document.getElementById('confirmButton');

inputCountries.forEach(countryElement => {
  countryElement.addEventListener('click', e => {
    selectedCountry = e.target.value;
    urlCountry = e.target.dataset.url;
  });
});

SelectinputCountries && SelectinputCountries.addEventListener('change', function(e) {
    selectedCountry = e.target.value;
    const selectedOption = this.options[this.selectedIndex];
    urlCountry = selectedOption.getAttribute('data-url');
});

confirmButton.addEventListener('click', e => {
  e.preventDefault();

  if (selectedCountry && urlCountry) {
    const selectedCountryElement = document.querySelector(`input[value="${selectedCountry}"]`);
    if (selectedCountryElement) {
      selectedCountryElement.checked = true;
    }
    window.location.href = urlCountry;
  }
});

if (window.matchMedia("(min-width: 768px)").matches) {
  const input = document.getElementById('country-search-input');
  const dropdown = document.getElementById('country-dropdown-list');
  const error = document.getElementById('country-search-error');
  const wrapper = document.querySelector('.country-search-wrapper');
  
  if (input && dropdown) {
    const items = dropdown.querySelectorAll('li');
    const toggleDropdown = (show) => {
      dropdown.style.display = show ? 'block' : 'none';
      wrapper.classList.toggle('open', show);
    };
    
    input.addEventListener('focus', () => toggleDropdown(true));
    
    input.addEventListener('input', (e) => {
      const search = e.target.value.toLowerCase().trim();
      let hasResults = false;
      
      const matchedItems = Array.from(items).map(item => {
        const countryName = item.getAttribute('data-country-name').toLowerCase();
        const match = search === '' || countryName.startsWith(search);
        return { item, match, countryName };
      });
      matchedItems.sort((a, b) => a.countryName.localeCompare(b.countryName));
      
      matchedItems.forEach(({ item, match }) => {
        item.style.display = match ? '' : 'none';
        if (match) hasResults = true;
        dropdown.appendChild(item);
      });
      
      error.style.display = !hasResults && search ? 'block' : 'none';
      toggleDropdown(true);
    });
    
    items.forEach(item => {
      item.addEventListener('click', function() {
        input.value = this.getAttribute('data-country-name');
        selectedCountry = this.getAttribute('data-country-iso');
        urlCountry = this.getAttribute('data-country-url');
        
        const radio = document.getElementById(selectedCountry);
        if (radio) radio.checked = true;
        
        toggleDropdown(false);
        error.style.display = 'none';
        
        items.forEach(li => li.setAttribute('data-is-selected', 'false'));
        this.setAttribute('data-is-selected', 'true');
      });
    });
    
    document.addEventListener('click', (e) => {
      if (!wrapper.contains(e.target)) toggleDropdown(false);
    });
  }
}
